import type { OutreachPresenceResponse, RenewOutreachPresenceResponse } from '@aegislab/shared';
import { apiClient } from '@/shared/api';

const base = (scenarioId: string) => `/campaigns/${scenarioId}/outreach-presence`;

/** 이 나라 초안을 만지는 중이라고 알린다 — 만료를 2분 뒤로 민다. */
export const renewOutreachPresence = async (
  scenarioId: string,
  country: string
): Promise<RenewOutreachPresenceResponse> => {
  const response = await apiClient.put<RenewOutreachPresenceResponse>(
    `${base(scenarioId)}/${country}`
  );
  return response.data;
};

/** 이 캠페인에서 지금 초안을 만지는 사람들. 만료된 임대는 서버가 뺀다. */
export const fetchOutreachPresence = async (
  scenarioId: string
): Promise<OutreachPresenceResponse> => {
  const response = await apiClient.get<OutreachPresenceResponse>(base(scenarioId));
  return response.data;
};
